export const API_BASE_URL = process.env.REACT_APP_SERVER_URL || ''; // e.g. "http://localhost:5000" or "/api"

const getAccessToken = () =>
  sessionStorage.getItem('accessToken') || localStorage.getItem('accessToken');

const getCompanyCode = () =>
  sessionStorage.getItem('companyCode') || localStorage.getItem('companyCode');

/**
 * Shared API helper — wraps fetch with JSON handling and error propagation.
 * Returns null when API_BASE_URL is not configured (static mode).
 *
 * @param {string} path - e.g. "/api/dependents/EMP001"
 * @param {object} options - fetch options (method, body, etc.)
 * @returns {Promise<any>|null}
 */
export function apiCall(path, options = {}) {
  if (!API_BASE_URL) return null;
  const token = getAccessToken();
  const companyCode = getCompanyCode();
  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};
  const companyHeaders = companyCode ? { Companycode: companyCode } : {};
  const isFormData =
    typeof FormData !== 'undefined' && options.body instanceof FormData;

  let requestBody;
  if (!options.body) {
    requestBody = undefined;
  } else if (isFormData) {
    requestBody = options.body;
  } else {
    requestBody = JSON.stringify(options.body);
  }

  const headers = {
    deviceType: 'web',
    ...authHeaders,
    ...companyHeaders,
  };
  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  }
  if (options.headers && typeof options.headers === 'object') {
    Object.assign(headers, options.headers);
  }

  return fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
    body: requestBody,
  }).then(res => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  });
}
